import { render, staticRenderFns } from "./product-improvements.vue?vue&type=template&id=f14898c4&"
import script from "./product-improvements.vue?vue&type=script&lang=js&"
export * from "./product-improvements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports